import QueryString from 'query-string';

export const getSearch = state => QueryString.parse(state.router.location.search);

export const getSearchParam = state => paramName => getSearch(state)[paramName];
